/**
 * Portal Manta · FormacoesSidebar
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, LOTES_INFO, ETAPA_LABEL, ETAPA_COR } from '../../globals.js';

function FormacoesSidebar({modo,loteKey,estudoId,estudos,onSelectLote,onSelectEstudo,onNovoEstudo,lote,focus,setFocus}){
  const [openL,setOpenL]=useState(true);
  const [openE,setOpenE]=useState(true);
  if(focus){
    return(<div onClick={()=>setFocus&&setFocus(false)} title="Clique para expandir" style={{width:32,background:'#16213A',borderRight:'1px solid rgba(255,255,255,.07)',display:'flex',flexDirection:'column',alignItems:'center',padding:'10px 0',cursor:'pointer',flexShrink:0}}>
      <span style={{fontSize:14,color:'#F4A76A',fontWeight:700,writingMode:'vertical-rl',transform:'rotate(180deg)',letterSpacing:1}}>FORMAÇÕES ▶</span>
    </div>);
  }
  return(<div style={{width:215,background:'#16213A',borderRight:'1px solid rgba(255,255,255,.07)',display:'flex',flexDirection:'column',flexShrink:0}}>
    <div style={{padding:'10px 12px',borderBottom:'1px solid rgba(255,255,255,.08)',fontSize:9,fontWeight:700,color:'rgba(255,255,255,.4)',letterSpacing:'.12em',textTransform:'uppercase'}}>Formações</div>

    {/* FORMAÇÃO 01 — LOTES INCORPORADOS */}
    <div style={{padding:'8px 8px 0'}}>
      <div onClick={()=>setOpenL(!openL)} style={{padding:'8px 10px',background:'rgba(212,104,42,.15)',border:'1px solid rgba(212,104,42,.3)',borderRadius:7,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
        <span style={{color:'#F4A76A',fontSize:9}}>{openL?'▼':'▶'}</span>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:4,marginBottom:1}}>
            <span style={{fontSize:9,fontWeight:700,color:'#F4A76A',fontFamily:'monospace'}}>2.1</span>
            <span style={{fontSize:10.5,fontWeight:700,color:'#fff',lineHeight:1.2}}>Formação 01</span>
            <span style={{padding:'0 5px',background:'rgba(32,87,168,.5)',color:'#93C5FD',fontSize:7.5,fontWeight:700,borderRadius:8,letterSpacing:'.04em'}}>ANTT</span>
          </div>
          <div style={{fontSize:9,color:'rgba(255,255,255,.45)'}}>Incorporadas · 3 lotes · PR</div>
        </div>
      </div>
      {openL&&<div style={{marginTop:4,marginLeft:6,paddingLeft:8,borderLeft:`2px solid ${V.orm}`}}>
        {LOTES_INFO.map((l,idx)=>{
          const active=modo==='lote'&&loteKey===l.k;
          return(<div key={l.k} onClick={()=>onSelectLote(l.k)} style={{
            padding:'6px 10px',marginTop:2,borderRadius:5,cursor:'pointer',
            background:active?'#D4682A':'transparent',
            color:active?'#fff':'rgba(255,255,255,.65)',
            borderLeft:active?'2px solid #F4A76A':'2px solid transparent',
            transition:'all .12s',display:'flex',alignItems:'center',gap:6,
          }}
          onMouseEnter={e=>{if(!active){e.currentTarget.style.background='rgba(212,104,42,.15)';e.currentTarget.style.color='#fff';}}}
          onMouseLeave={e=>{if(!active){e.currentTarget.style.background='transparent';e.currentTarget.style.color='rgba(255,255,255,.65)';}}}>
            <span style={{fontSize:9,opacity:active?1:.5}}>{active?'●':'○'}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:'flex',alignItems:'center',gap:4}}>
                <span style={{fontSize:9,fontWeight:700,fontFamily:'monospace',opacity:active?.95:.55}}>2.1.{idx+1}</span>
                <span style={{fontSize:10.5,fontWeight:600}}>{l.n}</span>
              </div>
              <div style={{fontSize:8.5,opacity:active?.9:.6}}>{l.ext}</div>
            </div>
          </div>);
        })}
      </div>}
    </div>

    {/* ESTUDOS EM ANDAMENTO */}
    <div style={{padding:'10px 8px 0'}}>
      <div onClick={()=>setOpenE(!openE)} style={{padding:'8px 10px',background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,255,255,.1)',borderRadius:7,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
        <span style={{color:'rgba(255,255,255,.5)',fontSize:9}}>{openE?'▼':'▶'}</span>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:4,marginBottom:1}}>
            <span style={{fontSize:9,fontWeight:700,color:'rgba(255,255,255,.4)',fontFamily:'monospace'}}>2.2</span>
            <span style={{fontSize:10.5,fontWeight:700,color:'rgba(255,255,255,.85)',lineHeight:1.2}}>Estudos em Andamento</span>
            <span style={{padding:'0 5px',background:'rgba(255,255,255,.15)',color:'rgba(255,255,255,.7)',fontSize:7.5,fontWeight:700,borderRadius:8,letterSpacing:'.04em'}}>↯</span>
          </div>
          <div style={{fontSize:9,color:'rgba(255,255,255,.4)'}}>Extração · {estudos.length} ativo{estudos.length!==1?'s':''}</div>
        </div>
      </div>
      {openE&&<div style={{marginTop:4,marginLeft:6,paddingLeft:8,borderLeft:`2px solid ${V.g2}`}}>
        {estudos.map((es,idx)=>{
          const active=modo==='estudo'&&estudoId===es.id;
          const cor=ETAPA_COR[es.etapa]||ETAPA_COR[1];
          return(<div key={es.id} onClick={()=>onSelectEstudo(es.id)} style={{
            padding:'6px 10px',marginTop:2,borderRadius:5,cursor:'pointer',
            background:active?'rgba(32,87,168,.35)':'transparent',
            color:active?'#fff':'rgba(255,255,255,.65)',
            borderLeft:active?'2px solid #93C5FD':'2px solid transparent',
            transition:'all .12s',display:'flex',alignItems:'flex-start',gap:6,
          }}
          onMouseEnter={e=>{if(!active){e.currentTarget.style.background='rgba(255,255,255,.06)';}}}
          onMouseLeave={e=>{if(!active){e.currentTarget.style.background='transparent';}}}>
            <span style={{fontSize:9,opacity:active?1:.5,marginTop:2}}>{active?'●':'○'}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:'flex',alignItems:'center',gap:4}}>
                <span style={{fontSize:9,fontWeight:700,fontFamily:'monospace',opacity:active?.95:.55}}>2.2.{idx+1}</span>
                <span style={{fontSize:10.5,fontWeight:600,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{es.nome}</span>
              </div>
              <div style={{fontSize:8.5,opacity:active?.9:.7,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{es.concessao}</div>
              <span style={{display:'inline-block',marginTop:3,padding:'1px 6px',fontSize:7.5,fontWeight:700,borderRadius:8,background:active?'rgba(255,255,255,.25)':cor.bg,color:active?'#fff':cor.c}}>{ETAPA_LABEL[es.etapa]}</span>
            </div>
          </div>);
        })}
        {/* Iniciar novo estudo */}
        <div onClick={onNovoEstudo} style={{
          padding:'7px 10px',marginTop:4,borderRadius:5,cursor:'pointer',
          border:'1px dashed rgba(212,104,42,.5)',color:'#F4A76A',
          display:'flex',alignItems:'center',gap:6,transition:'all .12s',
        }}
        onMouseEnter={e=>{e.currentTarget.style.background='rgba(212,104,42,.1)';}}
        onMouseLeave={e=>{e.currentTarget.style.background='transparent';}}>
          <span style={{fontSize:11,fontWeight:700}}>+</span>
          <span style={{fontSize:10,fontWeight:600}}>Iniciar novo estudo</span>
        </div>
      </div>}
    </div>

    {/* Rodapé com contexto ativo */}
    <div style={{marginTop:'auto',padding:'10px 12px',borderTop:'1px solid rgba(255,255,255,.07)',fontSize:9,color:'rgba(255,255,255,.35)',lineHeight:1.5}}>
      {modo==='lote'?(<>
        <div>Lote ativo: <b style={{color:'#F4A76A'}}>{lote.sig}</b></div>
        <div style={{marginTop:2}}>{lote.orgao} · {lote.uf} · {lote.fase}</div>
        <div>Base: {lote.data_base}</div>
      </>):(<>
        <div>Modo: <b style={{color:'#F4A76A'}}>Estudo em andamento</b></div>
        <div style={{marginTop:2}}>Extrator ANTT ativo</div>
        <div>Dados ainda não incorporados</div>
      </>)}
    </div>
  </div>);
}

export { FormacoesSidebar };
export default FormacoesSidebar;
